import React, { FunctionComponent } from 'react';
import styles from './HeaderBottomNav.module.scss';
import { WPMenuItem } from 'types/menus';
import cx from 'clsx';
import { LinkWrapper, Typography } from 'components/elements';
import { useLocation } from 'react-router-dom';
import { createMenuLink } from 'utils/links';

interface OwnProps {
  parent?: string;
  items: WPMenuItem[];
  visible: boolean;
  onClose?: () => void;
}

type HeaderBottomNavProps = JSX.IntrinsicElements['div'] & OwnProps;

const HeaderBottomNav: FunctionComponent<HeaderBottomNavProps> = props => {
  const { items, visible, className, onClose = () => {}, parent, ...rest } = props;
  const location = useLocation();

  const wrapperClassName = cx({
    [styles.wrapper]: true,
    [styles.opened]: visible,
    ...(className && { [className]: true }),
  });

  return (
    <div className={wrapperClassName} {...rest}>
      {items.map((item: WPMenuItem) => {
        const itemClassName = cx({
          [styles.item]: true,
          [styles.active]: location.pathname?.includes(`${parent && `/${parent}`}/${item.slug}`),
        });
        const isLink = item.url !== '#';
        return (
          <div key={item.ID} className={itemClassName}>
            {isLink && (
              <LinkWrapper className={styles.link} href={createMenuLink(item, parent)} onClick={() => onClose()}>
                <Typography mobile="new_neue_16" tablet="new_neue_16" desktop="new_neue_16" as="h3">
                  {item.title}
                </Typography>
              </LinkWrapper>
            )}
            {!isLink && (
              <div className={styles.notLink}>
                <Typography mobile="new_neue_16" tablet="new_neue_16" desktop="new_neue_16" as="h3">
                  {item.title}
                </Typography>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default HeaderBottomNav;
